import {
  collection,
  collectionGroup,
  getDocs,
  query,
  where,
} from "firebase/firestore";
import { db } from "../../firebase";

const getAllDealsCountForBusiness = async (bid) => {
  try {
    const DealsCollection = collection(db, "deals");

    let q = query(DealsCollection, where("bid", "==", bid));

    const DealsSnapshot = await getDocs(q);

    const count = DealsSnapshot.size;

    return count;
  } catch (error) {
    console.log(error);
    return 0;
  }
};

export default getAllDealsCountForBusiness;
